// Translations for MP Autobedrijf — NL (default) and EN

const dict = {
  nl: {
    // Nav
    "nav.home": "Home",
    "nav.occasions": "Occasions",
    "nav.diensten": "Diensten",
    "nav.over": "Over ons",
    "nav.reviews": "Reviews",
    "nav.contact": "Contact",
    "nav.afspraak": "Maak afspraak",
    "nav.beheer": "Beheer",

    // Common
    "common.bekijkAanbod": "Bekijk aanbod",
    "common.maakAfspraak": "Maak afspraak",
    "common.belDirect": "Bel direct",
    "common.contact": "Contact",
    "common.terug": "Terug",
    "common.laden": "Laden...",
    "common.geopend": "Geopend tot 17:30 — Arnhem Noord",
    "open.openUntil": "Nu geopend — sluit om {time}",
    "open.closedNext": "Nu gesloten — {label} vanaf {time}",
    "open.closed": "Momenteel gesloten",
    "open.today": "vandaag",
    "open.tomorrow": "morgen",
    "common.openTot": "Geopend tot {time} — Arnhem Noord",
    "common.dichtVandaag": "Vandaag gesloten — Arnhem Noord",
    "common.uit5": "/ 5 — {n} reviews",
    "common.gemiddeld": "Gemiddeld over {n} reviews",
    "common.versturen": "Versturen...",
    "common.verstuur": "Verstuur bericht",
    "common.optioneel": "(optioneel)",
    "common.required": "*",
    "common.allRights": "Alle rechten voorbehouden",

    // Hours
    "hours.mo": "Maandag",
    "hours.tu": "Dinsdag",
    "hours.we": "Woensdag",
    "hours.th": "Donderdag",
    "hours.fr": "Vrijdag",
    "hours.sa": "Zaterdag",
    "hours.su": "Zondag",
    "hours.opAfspraak": "Op afspraak",
    "hours.gesloten": "Gesloten",

    // Home
    "home.hero.title1": "Betrouwbare auto's",
    "home.hero.title2": "en service",
    "home.hero.title3": "in Arnhem.",
    "home.hero.subtitle": "Jonge occasions, eerlijk onderhoud, APK en import — allround vakmanschap onder één dak.",
    "home.usp.vakmanschap": "Vakmanschap",
    "home.usp.vakmanschapDesc": "Eerlijk advies en kwalitatief onderhoud door ervaren monteurs.",
    "home.usp.sterren": "4,9 / 5 sterren",
    "home.usp.sterrenDesc": "42 tevreden klanten geven ons een topbeoordeling.",
    "home.usp.allround": "Allround service",
    "home.usp.allroundDesc": "Verkoop, onderhoud, APK en reparatie — alles onder één dak.",
    "home.usp.import": "Auto Import",
    "home.usp.importDesc": "Op zoek naar iets specifieks? Wij importeren op aanvraag.",
    "home.featured.eyebrow": "Uitgelicht",
    "home.featured.title": "Recent binnen",
    "home.featured.viewAll": "Bekijk alle occasions",
    "home.featured.loading": "Auto's worden geladen...",
    "home.services.eyebrow": "Onze diensten",
    "home.services.title": "Alles voor uw auto",
    "home.services.intro": "Van aankoop tot APK. Wij zijn een compleet autobedrijf in Arnhem Noord met een eigen werkplaats en eerlijke prijzen.",
    "home.services.allCta": "Alle diensten",
    "home.services.tile1": "Verkoop",
    "home.services.tile1Desc": "Jonge, betrouwbare occasions met garantie.",
    "home.services.tile2": "Onderhoud",
    "home.services.tile2Desc": "Volledig dealer-niveau onderhoud, scherp geprijsd.",
    "home.services.tile3": "APK",
    "home.services.tile3Desc": "Snel & vakkundig keuringsstation.",
    "home.services.tile4": "Reparatie",
    "home.services.tile4Desc": "Storingen, remmen, ophanging — wij fixen het.",
    "home.cta.eyebrow": "Inruil mogelijk",
    "home.cta.title1": "Uw huidige auto inruilen?",
    "home.cta.title2": "Wij doen u een eerlijk bod.",
    "home.cta.inruilBtn": "Inruilformulier",
    "home.aptCta.eyebrow": "Afspraak in 1 minuut",
    "home.aptCta.title": "Maak hier gemakkelijk uw afspraak voor uw voertuig",
    "home.aptCta.text": "Kies een dienst, datum en tijd — u ontvangt direct een bevestiging per e-mail.",
    "home.aptCta.btn": "Plan uw afspraak",
    "nav.nieuws": "Tips",
    "tips.badge": "Nieuw",
    "tips.title": "Tips voor een gezonde auto",
    "tips.text": "APK, onderhoud & slimme autotips van onze monteurs.",
    "tips.btn": "Bekijk tips",
    "fin.title": "Financiering berekenen",
    "fin.from": "vanaf",
    "fin.perMonth": "p/m",
    "fin.down": "Aanbetaling",
    "fin.term": "Looptijd",
    "fin.months": "mnd",
    "fin.rate": "Rente",
    "fin.avg": "gemiddelde rente",
    "fin.loan": "Kredietbedrag",
    "fin.disclaimer": "Indicatieve berekening op basis van een gemiddelde jaarrente van 4,5%. De werkelijke rente verschilt per situatie en per kredietverstrekker. Dit is geen aanbod. Vraag ons naar de actuele financieringsmogelijkheden en voorwaarden.",
    "nieuws.eyebrow": "Nieuws & Tips",
    "nieuws.title": "Auto- & APK-tips",
    "nieuws.subtitle": "Praktische tips van onze monteurs om uw auto langer, veiliger en zuiniger te laten rijden — en om verrassingen bij de APK te voorkomen.",
    "nieuws.ctaTitle": "Onderhoud of APK nodig?",
    "nieuws.ctaSub": "Plan eenvoudig online een afspraak voor uw voertuig.",
    "nieuws.ctaBtn": "Plan uw afspraak",
    "nieuws.t1.tag": "Motor",
    "nieuws.t1.title": "Koude start: laat de oliedruk opbouwen",
    "nieuws.t1.body": "Start uw auto en laat de motor 20–30 seconden rustig stationair draaien voordat u wegrijdt, zeker bij koud weer. Zo verdeelt de olie zich over alle onderdelen en beperkt u motorslijtage. Vermijd hoge toeren tot de motor op temperatuur is.",
    "nieuws.t2.tag": "APK",
    "nieuws.t2.title": "APK: voorkom verrassingen",
    "nieuws.t2.body": "Controleer vooraf banden, verlichting, ruitenwissers en vloeistoffen. Kleine gebreken vooraf oplossen scheelt een herkeuring. U mag uw APK tot 2 maanden vervroegen zonder dat u de vervaldatum verliest — plan dus op tijd.",
    "nieuws.t3.tag": "Banden",
    "nieuws.t3.title": "Bandenspanning & profiel",
    "nieuws.t3.body": "Controleer maandelijks de bandenspanning bij koude banden. Wettelijk is minimaal 1,6 mm profiel verplicht, maar wij adviseren vervangen vanaf 3 mm voor een veilige remweg op nat wegdek.",
    "nieuws.t4.tag": "Onderhoud",
    "nieuws.t4.title": "Vloeistoffen regelmatig checken",
    "nieuws.t4.body": "Houd motorolie, koelvloeistof, remvloeistof en ruitensproeiervloeistof in de gaten. Een te laag olieniveau kan ernstige (en dure) motorschade veroorzaken. Bij twijfel: laat het even bij ons controleren.",
    "nieuws.t5.tag": "Veiligheid",
    "nieuws.t5.title": "Remmen: let op signalen",
    "nieuws.t5.body": "Piepende of trillende remmen, een langere remweg of een zacht rempedaal? Laat dit direct controleren. Remmen zijn cruciaal voor uw veiligheid en gaan langer mee bij tijdig onderhoud.",
    "nieuws.t6.tag": "Winter",
    "nieuws.t6.title": "Accu in de winter",
    "nieuws.t6.body": "Kou kan de capaciteit van uw accu bijna halveren. Rijd regelmatig wat langere ritten en laat de accu testen bij twijfel — vooral bij accu's ouder dan 4 jaar. Zo voorkomt u een lege accu op een koude ochtend.",
    "nieuws.t7.tag": "Airco",
    "nieuws.t7.title": "Airco ook in de winter gebruiken",
    "nieuws.t7.body": "Zet uw airco maandelijks even aan, ook in de winter. Dat houdt het systeem en de afdichtingen soepel en voorkomt lekkages. Laat het aircosysteem elke 2 jaar bijvullen en onderhouden.",
    "home.reviews.eyebrow": "Reviews",
    "home.reviews.fromN": "Van {n} klanten",
    "home.reviews.viewAll": "Alle reviews bekijken",

    // Occasions
    "occ.eyebrow": "Voorraad",
    "occ.title": "Onze occasions",
    "occ.subtitle": "Jong gebruikt, scherp geprijsd en met garantie. Filter op merk, brandstof, bouwjaar en prijs.",
    "occ.filters": "Filters",
    "occ.clear": "Wis",
    "occ.brand": "Merk",
    "occ.allBrands": "Alle merken",
    "occ.fuel": "Brandstof",
    "occ.minYear": "Min. bouwjaar",
    "occ.allYears": "Alles",
    "occ.fromYear": "vanaf {y}",
    "occ.maxPrice": "Max. prijs",
    "occ.found": "{n} auto's gevonden",
    "occ.foundOne": "1 auto gevonden",
    "occ.empty": "Geen auto's gevonden met deze filters.",
    "occ.clearFilters": "Filters wissen",

    // Detail
    "det.year": "Bouwjaar",
    "det.km": "Kilometerstand",
    "det.fuel": "Brandstof",
    "det.transmission": "Transmissie",
    "det.power": "Vermogen",
    "det.body": "Carrosserie",
    "det.desc": "Omschrijving",
    "det.askInfo": "Vraag info aan",
    "det.testDrive": "Plan een proefrit",
    "det.notFound": "Auto niet gevonden",
    "det.backToList": "Terug naar aanbod",

    // Diensten
    "srv.eyebrow": "Diensten",
    "srv.title": "Alles voor uw auto",
    "srv.subtitle": "Compleet autobedrijf in Arnhem Noord. Van verkoop, import en APK tot reparaties — al uw zaken op één adres.",
    "srv.s1": "Verkoop occasions",
    "srv.s1b1": "Jonge, dealer-onderhouden auto's",
    "srv.s1b2": "Eerlijke voorgeschiedenis & duidelijk verhaal",
    "srv.s1b3": "Inruil mogelijk en financiering bespreekbaar",
    "srv.s1b4": "Garantie op elke verkochte auto",
    "srv.s2": "Auto Import",
    "srv.s2.lead": "U kunt een aanvraag doen voor een specifieke auto. Wij regelen het ophalen bij de dealer (buitenland EU) en het complete invoerproces — van RDW-keuring tot BPM — compleet rijklaar gemaakt mét kenteken!",
    "srv.s2b1": "Aanvraag voor specifieke auto — wij gaan zoeken",
    "srv.s2b2": "Ophalen bij de dealer in buitenland (EU)",
    "srv.s2b3": "Volledige BPM-afhandeling en RDW-keuring",
    "srv.s2b4": "Compleet rijklaar mét kenteken — alles in één pakket",
    "srv.s3": "Onderhoud & Reparatie",
    "srv.s3b1": "Klein en groot onderhoud, alle merken",
    "srv.s3b2": "Remmen, ophanging, distributie, koppeling",
    "srv.s3b3": "Diagnose met merkspecifieke uitleesapparatuur",
    "srv.s3b4": "Heldere offerte vooraf — geen verrassingen",
    "srv.s4": "APK keuringen",
    "srv.s4b1": "RDW erkend keuringsstation",
    "srv.s4b2": "Snel klaar — vaak binnen het uur",
    "srv.s4b3": "Geen meerkosten bij directe reparatie",
    "srv.s4b4": "Combineer met klein onderhoud voor scherp tarief",
    "srv.s5": "Ophaal- & Brengservice / Voertuigtransport",
    "srv.s5.lead": "Ophaal- en brengservice en/of voertuigtransport is mogelijk op aanvraag. Ook als uw auto niet meer start of een andere storing heeft, halen wij het voertuig op en brengen het naar onze garage voor verdere diagnose en/of reparatie.",
    "srv.s5b1": "Ophalen & terugbrengen van uw voertuig op aanvraag",
    "srv.s5b2": "Ook als de auto niet meer start of een storing heeft",
    "srv.s5b3": "Veilig voertuigtransport naar onze garage",
    "srv.s5b4": "Verdere diagnose en reparatie in eigen werkplaats",
    "srv.cta.askQuestion": "Stel uw vraag",
    "srv.cta.bookApk": "Plan APK",
    "srv.cta.bookAppt": "Plan afspraak",
    "srv.cta.transport": "Vraag transport aan",

    // Over
    "over.eyebrow": "Over ons",
    "over.title": "Vakmanschap met een persoonlijk gezicht",
    "over.p1": "MP Autobedrijf is gevestigd in Arnhem Noord. Wij zijn een compleet autobedrijf waar verkoop van jonge occasions, import op aanvraag, onderhoud, reparatie en APK onder één dak samenkomen.",
    "over.p2": "Wat ons drijft? Eerlijk werk, een sterk netwerk en klanten die met een glimlach de deur uitlopen. Geen verkooppraatjes, maar nuchter advies en kwaliteit waar u op kunt rekenen.",
    "over.p3": "In onze werkplaats zit ervaring én moderne diagnose-apparatuur. Van een snelle APK tot grote reparaties — wij regelen het persoonlijk en transparant. Krijgt u onverwacht een storing? Bel of WhatsApp ons gerust, we kijken altijd wat we kunnen doen.",
    "over.address": "Adres",
    "over.stat1": "Sterren beoordeling",
    "over.stat2": "Tevreden klanten",
    "over.stat3": "Jaar vakmanschap",
    "over.stat4": "Persoonlijke service",

    // Reviews
    "rev.eyebrow": "Reviews",

    // Contact
    "con.eyebrow": "Contact",
    "con.title": "Laten we praten",
    "con.visit": "Bezoek ons",
    "con.email": "E-mail",
    "con.phone": "Bel ons",
    "con.hours": "Openingstijden",
    "con.name": "Naam",
    "con.subject": "Onderwerp",
    "con.message": "Bericht",
    "con.success": "Bedankt! We nemen snel contact met u op.",
    "con.error": "Er ging iets mis. Probeer het opnieuw of bel ons.",

    // Afspraak
    "apt.eyebrow": "Afspraak maken",
    "apt.title": "Plan uw bezoek",
    "apt.subtitle": "Kies een dienst, datum en tijd. U ontvangt direct een bevestiging per e-mail.",
    "apt.step1": "Kies een dienst",
    "apt.step2": "Kies een datum",
    "apt.step3": "Kies een tijd",
    "apt.step4": "Uw gegevens",
    "apt.svcAPK": "APK",
    "apt.svcOnderhoud": "Onderhoud",
    "apt.svcReparatie": "Reparatie",
    "apt.svcProefrit": "Proefrit",
    "apt.svcInruil": "Inruil",
    "apt.svcAnders": "Anders",
    "apt.your": "Uw gegevens",
    "apt.notesLabel": "Toelichting",
    "apt.kind": "Dienst",
    "apt.date": "Datum",
    "apt.time": "Tijd",
    "apt.min": "min",
    "apt.licensePlate": "Kenteken",
    "apt.brand": "Merk",
    "apt.model": "Model",
    "apt.phone": "Uw telefoonnummer",
    "apt.descLabel": "Omschrijving werkzaamheden",
    "apt.transport": "Ophalen/brengen gewenst",
    "apt.transportNote": "Prijs op aanvraag — wij nemen dan contact met u op!",
    "apt.priceLabel": "Prijs (indicatie)",
    "apt.pickDateFirst": "Kies eerst een datum om beschikbare tijden te zien.",
    "apt.noSlots": "Geen beschikbare tijden op deze dag. Kies een andere datum.",
    "apt.closedTitle": "Tijdelijk gesloten",
    "apt.closed": "Online afspraken zijn momenteel niet beschikbaar. Neem telefonisch contact met ons op via 085 060 5028.",
    "apt.booking": "Bezig met boeken",
    "apt.confirmTitle": "Afspraak bevestigd!",
    "apt.confirmNumber": "Afspraaknummer",
    "apt.confirmEmail": "U ontvangt een bevestiging per e-mail met alle details.",
    "apt.newBooking": "Nog een afspraak maken",
    "apt.confirm": "Afspraak bevestigen",
    "apt.confirmHint": "U ontvangt direct een e-mailbevestiging.",
    "apt.success": "Afspraak bevestigd!",
    "apt.errPickService": "Kies eerst een dienst",
    "apt.errPickDate": "Kies eerst een datum",
    "apt.errPickTime": "Kies een tijd",
    "apt.errFill": "Vul naam, telefoon en e-mail in",
    "apt.errPlate": "Kenteken is verplicht",

    // Inruil
    "tr.eyebrow": "Inruilen",
    "tr.title1": "Eerlijk bod",
    "tr.title2": "Geen gedoe.",
    "tr.subtitle": "Vul kort de gegevens van uw huidige auto in. Wij geven u snel een realistische inruilprijs.",
    "tr.your": "Uw gegevens",
    "tr.car": "Uw auto",
    "tr.plate": "Kenteken",
    "tr.model": "Model",
    "tr.year": "Bouwjaar",
    "tr.km": "Kilometerstand",
    "tr.notes": "Bijzonderheden / opmerkingen",
    "tr.notesPh": "Onderhoudsstaat, schades, opties...",
    "tr.photos": "Foto's van uw voertuig",
    "tr.photosHint": "Voeg duidelijke foto's toe (voor-, zij- en achterkant, interieur en eventuele schades). Dit helpt ons een nauwkeuriger bod te doen.",
    "tr.addPhotos": "Foto's toevoegen",
    "tr.photosCta": "Klik hier of op de knop om foto's toe te voegen",
    "tr.photosAdded": "{n} foto('s) toegevoegd",
    "tr.photosFailed": "{n} foto('s) mislukt. Probeer het opnieuw.",
    "tr.cta": "Vraag eerlijk bod aan",
    "tr.success": "Bedankt! We laten zo snel mogelijk een eerlijke inruilprijs weten.",

    // Footer
    "ft.tagline": "Betrouwbare jonge occasions, eerlijk onderhoud en APK in Arnhem Noord. Vakmanschap waar je op kunt rekenen.",
    "ft.nav": "Navigatie",
    "ft.contact": "Contact",
    "ft.inruil": "Inruilen",
    "ft.afspraak": "Afspraak",

    // Reviews data
    "revs.r1.text": "Heel tevreden met m'n autootje. Eerlijk verhaal, alles netjes geleverd. Snel contact bij een vraagje achteraf. Aanrader!",
    "revs.r2.text": "Snelle APK en goed advies over wat wel en niet nodig was. Geen gezeik, geen onnodige kosten. Top!",
    "revs.r3.text": "Mijn droomauto via MP geïmporteerd. Communicatie was perfect, alles van A tot Z geregeld inclusief BPM en RDW.",
    "revs.r4.text": "Eerlijke prijs, professionele werkplaats. De auto staat er weer als nieuw bij. Dank!",
    "revs.r5.text": "Klantgericht en geen verborgen kosten. Heldere offerte vooraf, prima werk. Ik kom zeker terug.",
    "revs.r6.text": "Snel geholpen toen ik dezelfde dag remklachten had. Vakmanschap merk je meteen.",
    "revs.r7.text": "Top auto gekocht bij MP. Eerlijk over de geschiedenis, nette afhandeling, garantie ook geregeld.",
    "revs.r8.text": "Combinatieafspraak APK + onderhoud was super efficiënt. Vriendelijke gasten daar.",
    "revs.r9.text": "Nette prijs voor inruil gekregen en mooie occasion teruggekregen. Eerlijk en correct.",
    "revs.r1.car": "Volkswagen Golf",
    "revs.r2.car": "APK keuring",
    "revs.r3.car": "BMW Import",
    "revs.r4.car": "Onderhoud Audi",
    "revs.r5.car": "Mercedes-Benz",
    "revs.r6.car": "Reparatie remmen",
    "revs.r7.car": "Volkswagen T-Roc",
    "revs.r8.car": "APK + onderhoud",
    "revs.r9.car": "Inruil + nieuwe occasion",
    "revs.r1.date": "2 weken geleden",
    "revs.r2.date": "1 maand geleden",
    "revs.r3.date": "1 maand geleden",
    "revs.r4.date": "2 maanden geleden",
    "revs.r5.date": "2 maanden geleden",
    "revs.r6.date": "3 maanden geleden",
    "revs.r7.date": "3 maanden geleden",
    "revs.r8.date": "4 maanden geleden",
    "revs.r9.date": "4 maanden geleden",
  },
  en: {
    "nav.home": "Home",
    "nav.occasions": "Used Cars",
    "nav.diensten": "Services",
    "nav.over": "About",
    "nav.reviews": "Reviews",
    "nav.contact": "Contact",
    "nav.afspraak": "Book appointment",
    "nav.beheer": "Admin",

    "common.bekijkAanbod": "View stock",
    "common.maakAfspraak": "Book appointment",
    "common.belDirect": "Call now",
    "common.contact": "Contact",
    "common.terug": "Back",
    "common.laden": "Loading...",
    "common.geopend": "Open until 17:30 — Arnhem North",
    "open.openUntil": "Open now — closes at {time}",
    "open.closedNext": "Closed now — {label} from {time}",
    "open.closed": "Currently closed",
    "open.today": "today",
    "open.tomorrow": "tomorrow",
    "common.openTot": "Open until {time} — Arnhem North",
    "common.dichtVandaag": "Closed today — Arnhem North",
    "common.uit5": "/ 5 — {n} reviews",
    "common.gemiddeld": "Average across {n} reviews",
    "common.versturen": "Sending...",
    "common.verstuur": "Send message",
    "common.optioneel": "(optional)",
    "common.required": "*",
    "common.allRights": "All rights reserved",

    "hours.mo": "Monday",
    "hours.tu": "Tuesday",
    "hours.we": "Wednesday",
    "hours.th": "Thursday",
    "hours.fr": "Friday",
    "hours.sa": "Saturday",
    "hours.su": "Sunday",
    "hours.opAfspraak": "By appointment",
    "hours.gesloten": "Closed",

    "home.hero.title1": "Reliable cars",
    "home.hero.title2": "and service",
    "home.hero.title3": "in Arnhem.",
    "home.hero.subtitle": "Young used cars, honest maintenance, MOT and import — all-round craftsmanship under one roof.",
    "home.usp.vakmanschap": "Craftsmanship",
    "home.usp.vakmanschapDesc": "Honest advice and quality maintenance by experienced mechanics.",
    "home.usp.sterren": "4.9 / 5 stars",
    "home.usp.sterrenDesc": "42 happy customers gave us a top rating.",
    "home.usp.allround": "All-round service",
    "home.usp.allroundDesc": "Sales, maintenance, MOT and repair — all under one roof.",
    "home.usp.import": "Car Import",
    "home.usp.importDesc": "Looking for something specific? We import on request.",
    "home.featured.eyebrow": "Featured",
    "home.featured.title": "Just arrived",
    "home.featured.viewAll": "View all stock",
    "home.featured.loading": "Loading cars...",
    "home.services.eyebrow": "Our services",
    "home.services.title": "Everything for your car",
    "home.services.intro": "From purchase to MOT. We are a complete car dealership in Arnhem North with our own workshop and fair prices.",
    "home.services.allCta": "All services",
    "home.services.tile1": "Sales",
    "home.services.tile1Desc": "Young, reliable used cars with warranty.",
    "home.services.tile2": "Maintenance",
    "home.services.tile2Desc": "Full dealer-grade maintenance, sharply priced.",
    "home.services.tile3": "MOT",
    "home.services.tile3Desc": "Fast & expert inspection station.",
    "home.services.tile4": "Repair",
    "home.services.tile4Desc": "Faults, brakes, suspension — we fix it.",
    "home.cta.eyebrow": "Trade-in available",
    "home.cta.title1": "Trading in your current car?",
    "home.cta.title2": "We'll give you a fair offer.",
    "home.cta.inruilBtn": "Trade-in form",
    "home.aptCta.eyebrow": "Book in 1 minute",
    "home.aptCta.title": "Easily book your appointment for your vehicle here",
    "home.aptCta.text": "Choose a service, date and time — you'll receive an instant email confirmation.",
    "home.aptCta.btn": "Book your appointment",
    "nav.nieuws": "Tips",
    "tips.badge": "New",
    "tips.title": "Tips for a healthy car",
    "tips.text": "MOT, maintenance & smart car tips from our mechanics.",
    "tips.btn": "View tips",
    "fin.title": "Calculate financing",
    "fin.from": "from",
    "fin.perMonth": "/mo",
    "fin.down": "Down payment",
    "fin.term": "Term",
    "fin.months": "mo",
    "fin.rate": "Interest",
    "fin.avg": "average rate",
    "fin.loan": "Loan amount",
    "fin.disclaimer": "Indicative calculation based on an average 4.5% annual interest rate. The actual rate varies per situation and per lender. This is not an offer. Ask us about current financing options and terms.",
    "nieuws.eyebrow": "News & Tips",
    "nieuws.title": "Car & MOT tips",
    "nieuws.subtitle": "Practical tips from our mechanics to keep your car running longer, safer and more economically — and to avoid surprises at the MOT.",
    "nieuws.ctaTitle": "Need maintenance or an MOT?",
    "nieuws.ctaSub": "Easily book an appointment for your vehicle online.",
    "nieuws.ctaBtn": "Book your appointment",
    "nieuws.t1.tag": "Engine",
    "nieuws.t1.title": "Cold start: let the oil pressure build up",
    "nieuws.t1.body": "Start your car and let the engine idle gently for 20–30 seconds before driving off, especially in cold weather. This spreads the oil across all components and reduces engine wear. Avoid high revs until the engine is up to temperature.",
    "nieuws.t2.tag": "MOT",
    "nieuws.t2.title": "MOT: avoid surprises",
    "nieuws.t2.body": "Check tyres, lights, wipers and fluids beforehand. Fixing small defects in advance saves a re-inspection. You may bring your MOT forward by up to 2 months without losing the expiry date — so plan in time.",
    "nieuws.t3.tag": "Tyres",
    "nieuws.t3.title": "Tyre pressure & tread",
    "nieuws.t3.body": "Check tyre pressure monthly on cold tyres. Legally a minimum of 1.6 mm tread is required, but we recommend replacing from 3 mm for a safe braking distance on wet roads.",
    "nieuws.t4.tag": "Maintenance",
    "nieuws.t4.title": "Check fluids regularly",
    "nieuws.t4.body": "Keep an eye on engine oil, coolant, brake fluid and washer fluid. A low oil level can cause serious (and expensive) engine damage. When in doubt, let us check it for you.",
    "nieuws.t5.tag": "Safety",
    "nieuws.t5.title": "Brakes: watch for warning signs",
    "nieuws.t5.body": "Squeaking or vibrating brakes, a longer braking distance or a soft brake pedal? Have this checked immediately. Brakes are crucial for your safety and last longer with timely maintenance.",
    "nieuws.t6.tag": "Winter",
    "nieuws.t6.title": "Battery in winter",
    "nieuws.t6.body": "Cold can almost halve your battery's capacity. Drive longer trips regularly and have the battery tested when in doubt — especially for batteries older than 4 years. This prevents a dead battery on a cold morning.",
    "nieuws.t7.tag": "Air conditioning",
    "nieuws.t7.title": "Use your air conditioning in winter too",
    "nieuws.t7.body": "Turn on your air conditioning briefly every month, even in winter. This keeps the system and seals supple and prevents leaks. Have the AC system refilled and serviced every 2 years.",
    "home.reviews.eyebrow": "Reviews",
    "home.reviews.fromN": "From {n} customers",
    "home.reviews.viewAll": "View all reviews",

    "occ.eyebrow": "Stock",
    "occ.title": "Our used cars",
    "occ.subtitle": "Lightly used, sharply priced and with warranty. Filter by brand, fuel, year and price.",
    "occ.filters": "Filters",
    "occ.clear": "Clear",
    "occ.brand": "Brand",
    "occ.allBrands": "All brands",
    "occ.fuel": "Fuel",
    "occ.minYear": "Min. year",
    "occ.allYears": "All",
    "occ.fromYear": "from {y}",
    "occ.maxPrice": "Max price",
    "occ.found": "{n} cars found",
    "occ.foundOne": "1 car found",
    "occ.empty": "No cars match these filters.",
    "occ.clearFilters": "Clear filters",

    "det.year": "Year",
    "det.km": "Mileage",
    "det.fuel": "Fuel",
    "det.transmission": "Transmission",
    "det.power": "Power",
    "det.body": "Body type",
    "det.desc": "Description",
    "det.askInfo": "Request info",
    "det.testDrive": "Book a test drive",
    "det.notFound": "Car not found",
    "det.backToList": "Back to stock",

    "srv.eyebrow": "Services",
    "srv.title": "Everything for your car",
    "srv.subtitle": "Complete car dealership in Arnhem North. Sales, import, MOT and repairs — all in one place.",
    "srv.s1": "Used car sales",
    "srv.s1b1": "Young, dealer-maintained cars",
    "srv.s1b2": "Honest history & clear story",
    "srv.s1b3": "Trade-in possible, financing negotiable",
    "srv.s1b4": "Warranty on every car sold",
    "srv.s2": "Car Import",
    "srv.s2.lead": "Send us a request for a specific car. We pick it up at the EU dealer and handle the complete import process — from RDW inspection to BPM — fully road-ready with Dutch licence plate!",
    "srv.s2b1": "Request a specific car — we'll source it",
    "srv.s2b2": "Pickup at the dealer abroad (EU)",
    "srv.s2b3": "Full BPM handling and RDW inspection",
    "srv.s2b4": "Fully road-ready with Dutch plate — one package",
    "srv.s3": "Maintenance & Repair",
    "srv.s3b1": "Small and large maintenance, all brands",
    "srv.s3b2": "Brakes, suspension, timing, clutch",
    "srv.s3b3": "Diagnostics with brand-specific tools",
    "srv.s3b4": "Clear quote up front — no surprises",
    "srv.s4": "MOT inspections",
    "srv.s4b1": "RDW certified inspection station",
    "srv.s4b2": "Done quickly — often within the hour",
    "srv.s4b3": "No extra cost for direct repairs",
    "srv.s4b4": "Combine with maintenance for sharp rate",
    "srv.s5": "Pickup & Delivery / Vehicle Transport",
    "srv.s5.lead": "Pickup and delivery and/or vehicle transport is available on request. Even if your car won't start or has another fault, we collect the vehicle and bring it to our garage for further diagnosis and/or repair.",
    "srv.s5b1": "Pickup & return of your vehicle on request",
    "srv.s5b2": "Also when the car won't start or has a fault",
    "srv.s5b3": "Safe vehicle transport to our garage",
    "srv.s5b4": "Further diagnosis and repair in our own workshop",
    "srv.cta.askQuestion": "Ask your question",
    "srv.cta.bookApk": "Book MOT",
    "srv.cta.bookAppt": "Book appointment",
    "srv.cta.transport": "Request transport",

    "over.eyebrow": "About us",
    "over.title": "Craftsmanship with a personal face",
    "over.p1": "MP Autobedrijf is located in Arnhem North. We are a complete car dealership combining young used car sales, import on request, maintenance, repair and MOT under one roof.",
    "over.p2": "What drives us? Honest work, a strong network and customers who walk out smiling. No sales talk, just clear advice and quality you can rely on.",
    "over.p3": "Our workshop combines experience with modern diagnostic equipment. From a quick MOT to major repairs — we handle it personally and transparently. Unexpected fault? Call or WhatsApp us, we'll always see what we can do.",
    "over.address": "Address",
    "over.stat1": "Star rating",
    "over.stat2": "Happy customers",
    "over.stat3": "Years of craft",
    "over.stat4": "Personal service",

    "rev.eyebrow": "Reviews",

    "con.eyebrow": "Contact",
    "con.title": "Let's talk",
    "con.visit": "Visit us",
    "con.email": "Email",
    "con.phone": "Call us",
    "con.hours": "Opening hours",
    "con.name": "Name",
    "con.subject": "Subject",
    "con.message": "Message",
    "con.success": "Thank you! We'll get back to you soon.",
    "con.error": "Something went wrong. Please try again or call us.",

    "apt.eyebrow": "Book appointment",
    "apt.title": "Plan your visit",
    "apt.subtitle": "Choose a service, date and time. You'll receive an instant email confirmation.",
    "apt.step1": "Choose a service",
    "apt.step2": "Choose a date",
    "apt.step3": "Choose a time",
    "apt.step4": "Your details",
    "apt.svcAPK": "MOT",
    "apt.svcOnderhoud": "Maintenance",
    "apt.svcReparatie": "Repair",
    "apt.svcProefrit": "Test drive",
    "apt.svcInruil": "Trade-in",
    "apt.svcAnders": "Other",
    "apt.your": "Your details",
    "apt.notesLabel": "Notes",
    "apt.kind": "Service",
    "apt.date": "Date",
    "apt.time": "Time",
    "apt.min": "min",
    "apt.licensePlate": "Licence plate",
    "apt.brand": "Make",
    "apt.model": "Model",
    "apt.phone": "Your phone number",
    "apt.descLabel": "Description of work",
    "apt.transport": "Pickup/delivery requested",
    "apt.transportNote": "Price on request — we'll get in touch with you!",
    "apt.priceLabel": "Price (indication)",
    "apt.pickDateFirst": "Pick a date first to see available times.",
    "apt.noSlots": "No available times on this day. Please choose another date.",
    "apt.closedTitle": "Temporarily closed",
    "apt.closed": "Online bookings are currently unavailable. Please call us at 085 060 5028.",
    "apt.booking": "Booking",
    "apt.confirmTitle": "Appointment confirmed!",
    "apt.confirmNumber": "Appointment number",
    "apt.confirmEmail": "You'll receive an email confirmation with all the details.",
    "apt.newBooking": "Make another appointment",
    "apt.confirm": "Confirm appointment",
    "apt.confirmHint": "You'll receive an instant email confirmation.",
    "apt.success": "Appointment confirmed!",
    "apt.errPickService": "Please choose a service first",
    "apt.errPickDate": "Please pick a date first",
    "apt.errPickTime": "Please pick a time",
    "apt.errFill": "Please fill in name, phone and email",
    "apt.errPlate": "Licence plate is required",

    "tr.eyebrow": "Trade-in",
    "tr.title1": "Fair offer",
    "tr.title2": "No hassle.",
    "tr.subtitle": "Briefly fill in your current car details. We'll quickly give you a realistic trade-in price.",
    "tr.your": "Your details",
    "tr.car": "Your car",
    "tr.plate": "Licence plate",
    "tr.model": "Model",
    "tr.year": "Year",
    "tr.km": "Mileage",
    "tr.notes": "Notes / remarks",
    "tr.notesPh": "Maintenance condition, damage, options...",
    "tr.photos": "Photos of your vehicle",
    "tr.photosHint": "Add clear photos (front, side and rear, interior and any damage). This helps us make a more accurate offer.",
    "tr.addPhotos": "Add photos",
    "tr.photosCta": "Click here or the button to add photos",
    "tr.photosAdded": "{n} photo(s) added",
    "tr.photosFailed": "{n} photo(s) failed. Please try again.",
    "tr.cta": "Request fair offer",
    "tr.success": "Thanks! We'll get back to you shortly with a fair trade-in price.",

    "ft.tagline": "Reliable young used cars, honest maintenance and MOT in Arnhem North. Craftsmanship you can rely on.",
    "ft.nav": "Navigation",
    "ft.contact": "Contact",
    "ft.inruil": "Trade-in",
    "ft.afspraak": "Appointment",

    "revs.r1.text": "Very happy with my little car. Honest story, all delivered neatly. Quick reply for follow-up questions. Recommended!",
    "revs.r2.text": "Quick MOT and good advice on what was needed. No fuss, no unnecessary costs. Top!",
    "revs.r3.text": "Imported my dream car via MP. Communication was perfect, everything handled including BPM and RDW.",
    "revs.r4.text": "Fair price, professional workshop. Car looks like new again. Thanks!",
    "revs.r5.text": "Customer-focused and no hidden costs. Clear quote up front, great work. I'll definitely return.",
    "revs.r6.text": "Helped quickly when I had brake issues the same day. You can tell the craftsmanship.",
    "revs.r7.text": "Bought a great car at MP. Honest about history, smooth handling, warranty arranged.",
    "revs.r8.text": "Combined MOT + maintenance was super efficient. Friendly people there.",
    "revs.r9.text": "Got a fair trade-in price and a nice used car back. Honest and correct.",
    "revs.r1.car": "Volkswagen Golf",
    "revs.r2.car": "MOT inspection",
    "revs.r3.car": "BMW Import",
    "revs.r4.car": "Audi maintenance",
    "revs.r5.car": "Mercedes-Benz",
    "revs.r6.car": "Brake repair",
    "revs.r7.car": "Volkswagen T-Roc",
    "revs.r8.car": "MOT + maintenance",
    "revs.r9.car": "Trade-in + new car",
    "revs.r1.date": "2 weeks ago",
    "revs.r2.date": "1 month ago",
    "revs.r3.date": "1 month ago",
    "revs.r4.date": "2 months ago",
    "revs.r5.date": "2 months ago",
    "revs.r6.date": "3 months ago",
    "revs.r7.date": "3 months ago",
    "revs.r8.date": "4 months ago",
    "revs.r9.date": "4 months ago",
  },
};

export default dict;
